module.exports = __webpack_public_path__ + "assets/img/11_1083_big.0ab69f4c.jpg";